import { ROUTES } from '#/config/routes';
import {
  createFixedMultiFilterMeta,
  createTextFilterMeta,
} from '#/modules/commonComponents/table/columnFilterMeta';
import { createEditLinkColumn } from '#/modules/commonComponents/table/tableColumnHelpers';
import { renderEntityStatusBadge } from '#/modules/commonComponents/table/entityStatusIconHelpers';
import TruncatedTextWithTooltip from '#/modules/commonComponents/table/TruncatedTextWithTooltip';
import {
  PROCESSING_FACTORY_STATUS_FILTER_OPTIONS,
} from '#/modules/momMgmt/settings/processingFactory/helper/processingFactoryFilterOptions';

export function buildProcessingFactoryColumns({
  filters = {},
  onFilterChange,
  canShowEdit = () => true,
}) {
  return [
    createEditLinkColumn({
      getEditPath: (row) => ROUTES.processingFactoryEdit(row.id),
      canShowEdit,
    }),
    {
      header: '代號',
      accessorKey: 'code',
      size: 120,
      enableColumnFilter: true,
      meta: createTextFilterMeta({
        key: 'code',
        label: '代號',
        filterValue: filters.code,
        onChange: (value) => onFilterChange('code', value),
        placeholder: '搜尋代號',
      }),
      cell: ({ row }) => (
        <TruncatedTextWithTooltip text={row.original?.code || '—'} />
      ),
    },
    {
      header: '名稱',
      accessorKey: 'name',
      size: 180,
      enableColumnFilter: true,
      meta: {
        cellClassName: 'td_left',
        ...createTextFilterMeta({
          key: 'name',
          label: '名稱',
          filterValue: filters.name,
          onChange: (value) => onFilterChange('name', value),
          placeholder: '搜尋名稱',
        }),
      },
      cell: ({ row }) => (
        <TruncatedTextWithTooltip text={row.original?.name || '—'} />
      ),
    },
    {
      header: '中文名',
      accessorKey: 'chineseName',
      size: 140,
      enableColumnFilter: true,
      meta: {
        cellClassName: 'td_left',
        ...createTextFilterMeta({
          key: 'chineseName',
          label: '中文名',
          filterValue: filters.chineseName,
          onChange: (v) => onFilterChange('chineseName', v),
          placeholder: '搜尋中文名',
        }),
      },
      cell: ({ row }) => (
        <TruncatedTextWithTooltip text={row.original?.chineseName || '—'} />
      ),
    },
    {
      header: '統編',
      accessorKey: 'taxIdNumber',
      size: 120,
      enableColumnFilter: true,
      meta: {
        cellClassName: 'td_left',
        ...createTextFilterMeta({
          key: 'taxIdNumber',
          label: '統編',
          filterValue: filters.taxIdNumber,
          onChange: (v) => onFilterChange('taxIdNumber', v),
          placeholder: '搜尋統編',
        }),
      },
      cell: ({ row }) => (
        <TruncatedTextWithTooltip text={row.original?.taxIdNumber || '—'} />
      ),
    },
    {
      header: '電話',
      accessorKey: 'phone',
      size: 120,
      enableColumnFilter: true,
      meta: {
        cellClassName: 'td_left',
        ...createTextFilterMeta({
          key: 'phone',
          label: '電話',
          filterValue: filters.phone,
          onChange: (v) => onFilterChange('phone', v),
          placeholder: '搜尋電話',
        }),
      },
      cell: ({ row }) => (
        <TruncatedTextWithTooltip text={row.original?.phone || '—'} />
      ),
    },
    {
      header: '備註',
      accessorKey: 'remark',
      size: 160,
      enableSorting: false,
      meta: { cellClassName: 'td_left' },
      cell: ({ row }) => (
        <TruncatedTextWithTooltip text={row.original?.remark || '—'} />
      ),
    },
    {
      id: 'status',
      header: '狀態',
      accessorKey: 'status',
      size: 96,
      enableColumnFilter: true,
      cell: ({ getValue }) => renderEntityStatusBadge(getValue()),
      meta: createFixedMultiFilterMeta({
        key: 'status',
        label: '狀態',
        options: PROCESSING_FACTORY_STATUS_FILTER_OPTIONS,
        filterValue: filters.status,
        onChange: (value) => onFilterChange('status', value),
      }),
    },
  ];
}
